<template>
<main-content>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-label>
                <kt-panel-header-title>
                    {{ $t('panel.profile.header_title') }}
                </kt-panel-header-title>
            </kt-panel-header-label>
        </kt-panel-header>
        <kt-panel-body>
            <kt-nav space="md" size="lg">
                <kt-nav-item >
                    <router-link class="kt-nav__link" to="/profile/update">
                        <kt-nav-link-icon type="fa" name="edit"></kt-nav-link-icon>
                        <kt-nav-link-text v-if="current_user.user_type == user_types.REAL"> {{ $t('panel.profile.nav.edit') }} </kt-nav-link-text>
                        <kt-nav-link-text v-else-if="current_user.user_type == user_types.LEGAL"> {{ $t('panel.profile.nav.edit_company_info') }} </kt-nav-link-text>
                    </router-link>
                </kt-nav-item>

                <kt-nav-item>
                    <router-link class="kt-nav__link" to="/profile/addresses">
                        <kt-nav-link-icon type="fa" name="map"></kt-nav-link-icon>
                        <kt-nav-link-text> {{ $t('panel.profile.nav.address') }} </kt-nav-link-text>
                    </router-link>
                </kt-nav-item>
                
                <kt-nav-item>
                    <router-link class="kt-nav__link" to="/profile/sheba-numbers">
                        <kt-nav-link-icon type="fa" name="credit-card"></kt-nav-link-icon>
                        <kt-nav-link-text> {{ $t('panel.profile.nav.bankAccounts') }} </kt-nav-link-text>
                    </router-link>
                </kt-nav-item>

                <kt-nav-item v-if="!is_authenticated">
                    <router-link class="kt-nav__link" to="/profile/authenticate">
                        <kt-nav-link-icon type="fa" name="lock"></kt-nav-link-icon>
                        <kt-nav-link-text> {{ $t('panel.profile.nav.authentication') }} </kt-nav-link-text>
                    </router-link>
                </kt-nav-item>
                <kt-nav-item>
                    <router-link class="kt-nav__link" to="/profile/change-password">
                        <kt-nav-link-icon type="fa" name="key"></kt-nav-link-icon>
                        <kt-nav-link-text> {{ $t('panel.profile.nav.change_password') }} </kt-nav-link-text>
                    </router-link>
                </kt-nav-item>
            </kt-nav>
        </kt-panel-body>
    </kt-panel>
    <slot></slot>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import { userTypes } from '@/constants/userTypes';

export default {
    components: {
        'main-content': mainContent
    },
    data() {
        return {
            user_types: userTypes,
        }
    },
    computed: {
        ...mapGetters('user', [
            'current_user', 'is_authenticated', 'is_authenticated_pending'
        ]),
    },
}
</script>

<style>

</style>